import { useState } from "react";
import { Rocket, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface QuickWinsCardProps {
  wins: string[];
  collapsible?: boolean;
}

const QuickWinsCard = ({ wins, collapsible = false }: QuickWinsCardProps) => {
  const [isOpen, setIsOpen] = useState(!collapsible);

  return (
    <div className="bg-card border border-border rounded-2xl p-5 fade-in-up opacity-0 stagger-4">
      <button
        type="button"
        className={cn(
          "flex items-center gap-2 w-full text-left",
          collapsible ? "cursor-pointer" : "cursor-default",
          !isOpen && "mb-0",
          isOpen && "mb-4"
        )}
        onClick={() => collapsible && setIsOpen(!isOpen)}
        disabled={!collapsible}
      >
        <Rocket className="w-5 h-5 text-primary" />
        <h3 className="font-display font-semibold text-base flex-1">Quick Wins</h3>
        {collapsible && (
          <ChevronDown className={cn("w-4 h-4 text-muted-foreground transition-transform duration-200", isOpen && "rotate-180")} />
        )}
      </button>
      {isOpen && (
        <ul className="space-y-3">
          {wins?.map((win, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2 shrink-0" />
              <span className="text-sm text-muted-foreground leading-relaxed">{win}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default QuickWinsCard;
